import { toastNotify } from "../utils/Utils";
import axios from "axios";
import { axiosInstanceAuth } from "./index";
import _ from "lodash";

const getCurrentPath = () => {
  if (typeof window !== "undefined") {
    return window.location.pathname;
  }
  return null;
};

const handleLogout = () => {
  const currentPath = getCurrentPath();
  if (currentPath !== "/signin") {
    const dompetUser = JSON.parse(localStorage.getItem("dompet_user") || "null");
    if (dompetUser?.identifier) {
      axiosInstanceAuth.post(`auth/logout/${dompetUser.identifier}`).catch(() => {});
    }
    localStorage.clear();
    window.location.href = "/signin";
  }
};

async function axiosWithRetry(config, retries = 3, delay = 1000) {
  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    const code = error.code || error.response?.status;

    if (
      retries > 0 &&
      (code === "ECONNABORTED" || code === "ERR_NETWORK" || code === 502)
    ) {
      // console.warn(`Retrying ${config.method.toUpperCase()} request in ${delay}ms... (${retries} retries left)`)

      await new Promise((resolve) => setTimeout(resolve, delay));
      return axiosWithRetry(config, retries - 1, delay * 2);
    }
    toastNotify(
      "The server is not responding. Your connection is either slow or experiencing issues.",
      "error",
    );

    return Promise.reject(error);
  }
}

axiosInstanceAuth.interceptors.request.use(
  (config) => {
    // Lakukan manipulasi request di sini, seperti menambahkan header
    const token = localStorage.getItem("token_user");
    config = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
        "x-Lang": "en",
      },
    };

    return config;
  },
  (error) => {
    // Tangani kesalahan request di sini
    return Promise.reject(error);
  },
);

// Menambahkan interceptor untuk response
axiosInstanceAuth.interceptors.response.use(
  (response) => {
    // Lakukan manipulasi response di sini
    const error = response?.data?.err;
    const message = response?.data?.msg;
    let detailMessage =
      typeof message === "object" ? _.map(message).join(", ") : message;

    if (typeof error === "boolean" && error === true) {
      if (typeof message === "string") {
        toastNotify(message, "error");
        return Promise.reject(new Error(message));
      }
      if (typeof message === "object") {
        const errorMessage = detailMessage;
        toastNotify(errorMessage, "error");
        return Promise.reject(new Error(errorMessage));
      }
    }

    return { error, message, detailMessage, ...response };
  },
  (error) => {
    const currentPath = getCurrentPath();
    // Tangani kesalahan response di sini
    const status = error?.response?.status;
    const code = error?.code;
    const message = error?.response?.data?.msg;
    let detailMessage =
      typeof message === "object" ? _.map(message).join(", ") : message;
    let errorMessage =
      typeof message === "object" ? _.map(message).join(", ") : message;

    switch (status) {
      case 400:
      case 422:
        errorMessage = `Please check your request. (${errorMessage})`;
        break;
      case 401:
        // handle massage error session check
        if (error.config.url === "auth/me" && currentPath === "/signin") {
          return;
        } else {
          if (error.config.url === "auth/me") {
            handleLogout();
          }
          toastNotify(errorMessage, "error");
          errorMessage = `Unauthorized. (${errorMessage})`;
        }
        break;
      case 403:
        errorMessage = "Your session has expired, please log in again.";
        break;
      case 404:
        errorMessage = "The requested action was not found.";
        break;
      case 500:
        errorMessage = "Server error. Please try again later.";
        break;
      case 502:
      case 503:
      case 504:
        errorMessage = "The server is currently unavailable.";
        break;
      default:
        break;
    }

    switch (code) {
      case "ECONNABORTED":
      case "ERR_NETWORK":
        const method = error.config?.method?.toUpperCase();

        if (
          !error.config._retry &&
          (method === "GET" ||
            method === "PATCH" ||
            (method === "POST" && error.config.retry === true))
        ) {
          error.config._retry = true;
          // console.warn(`Network error on ${method} request. Attempting retry...`)

          return axiosWithRetry(error.config, 3)
            .then((response) => response)
            .catch((retryError) => {
              // console.error('All retry attempts failed:', retryError)
              return Promise.reject(retryError);
            });
        }

        // console.error('Network issue, no retry performed.')
        return Promise.reject(error);
      default:
        break;
    }

    return { error: true, status, code, message, detailMessage, errorMessage };
  },
);

export const requestAuthGet = (url, config) =>
  axiosInstanceAuth.get(url, config);
export const requestAuthPost = (url, formData, config) =>
  axiosInstanceAuth.post(url, formData, config);
export const requestAuthPut = (url, formData, config) =>
  axiosInstanceAuth.put(url, formData, config);
export const requestAuthDelete = (url, config) =>
  axiosInstanceAuth.delete(url, config);
export const requestAuthPatch = (url, formData, config) =>
  axiosInstanceAuth.patch(url, formData, config);

export default axiosInstanceAuth;
